export default {
  transaction: {
    title: 'Transaction',
    select: 'Select',
    all: 'All',
    type: 'Type',
    amount: 'Amount',
    loading: 'Loading...',
    noMoreData: 'No more data',
    mockSuccess: 'Mock Success',
    mockFail: 'Mock Fail',
    mockSuccessDone: 'Mock success done',
    mockFailDone: 'Mock fail done',
    mockFailed: 'Mock failed',
    today: 'Today',
    yesterday: 'Yesterday',
    last3Days: 'Last 3 days',
    last7Days: 'Last 7 days',
    last15Days: 'Last 15 days',
    last30Days: 'Last 30 days',
    allTypes: 'All Types',
    deposit: 'Deposit',
    withdrawal: 'Withdrawal',
    withdrawalRefund: 'Withdrawal Refund',
    bet: 'Bet',
    win: 'Win',
    manualAdd: 'Manual Add',
    manualSubtract: 'Manual Subtract',
    commission: 'Commission',
    bonus: 'Bonus',
    vipUpgradeReward: 'VIP Upgrade Reward',
    vipSalary: 'VIP Salary',
    gameOutPrincipal: 'Game Out - Principal',
    gameOutBonus: 'Game Out - Bonus',
    bonusTransferOut: 'Bonus Transfer Out',
    allStats: 'All Stats',
    underReview: 'Under Review',
    pendingPayout: 'Pending Payout',
    successful: 'Successful',
    failed: 'Failed',
    cancelled: 'Cancelled',
    processing: 'Processing',
  },
};
